import { takeLatest, put, select, all } from 'redux-saga/effects';
import { message } from 'antd';
import getMetricsData from '@api/metricContainer';
import * as actions from './actions';
import { initBenchmarkKPI } from '@store/overviewDashboard/benchmark/actions';
import * as types from './types';
import * as helpers from './helper';
import * as adContentHelper from './adContentHelper';
import * as baseTypes from '../base/types';
import { intervalSelector, filterSelector, selectedKPIConfigSelector } from '../base/selectors';
import { granularity as getGranularity } from '@utils';
import { IMPROVEMENT_OPPORTUNITY_METRICS, IMPROVEMENT_OPPORTUNITY_ADMETRICS } from '@src/utils/kpi';
import { autoRequest } from '@src/api/createRequestStore';
import { activeTabSelector } from './selectors';
import { AdContentTabKey, ChartsTabKey, BenchmarkTabKey } from './reducer';

function* getChartData() {
  const activeTab = yield select(activeTabSelector);
  const interval = yield select(intervalSelector);
  const filter = yield select(filterSelector);
  const metrics = IMPROVEMENT_OPPORTUNITY_METRICS;
  const adMetrics = IMPROVEMENT_OPPORTUNITY_ADMETRICS;
  const kpiConfig = yield select(selectedKPIConfigSelector);

  let payload = null;
  let storeType = '';
  // timeseries data
  if (activeTab === ChartsTabKey || activeTab === BenchmarkTabKey) {
    storeType = types.IMP_OPP_CHARTS;
    const granularity = getGranularity(interval.from, interval.to, false, true);
    payload = yield helpers.createQuery(
      metrics,
      `${interval.from}/${interval.to}`,
      filter.rule,
      granularity,
      kpiConfig,
    );
    yield put(actions.fetchOppCharts());
  } else if (activeTab === AdContentTabKey) {
    storeType = types.IMP_OPP_AD_CONTENT;
    payload = yield adContentHelper.createAdQuery({
      metrics: [...adMetrics],
      interval: `${interval.from}/${interval.to}`,
      filter: filter.rule,
      kpiConfig,
    });
    yield put(actions.fetchAdContentTable());
  }

  try {
    yield autoRequest(getMetricsData, storeType, payload);
  } catch (error) {
    const errorMsg = error.message || 'Unknown error!';
    message.error(errorMsg);
  }
}

function* initRequest() {
  yield all([put(actions.initOppCharts()), put(actions.initAdContentTable())]);
}

function* watchInitRequest() {
  yield takeLatest([types.INIT], initRequest);
}

function* watchParamChanges() {
  yield takeLatest(
    [
      types.FETCH_DATA,
      baseTypes.SET_INTERVAL,
      baseTypes.APPLY_FILTER,
      baseTypes.SET_SELECTED_KPI_CONFIG,
      types.SET_ACTIVE_TAB,
    ],
    getChartData,
  );
}

export default [watchInitRequest, watchParamChanges];
